import { Grid2, Tabs as MuiTabs, Tab } from "@mui/material";
import { useMemo } from "react";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../store/slices/UI";
import filterObjKeys from "../../../utility/misc/filterObjectKeys";
import { defaultTab } from "./genericIDs";

const Tabs = (props) => {
  const { id = defaultTab, onChange, panels = [], disableDefault, UIText, labelProps = {}, size = 12, clearOnUnmount } = props;
  const filteredProps = filterObjKeys(props, "onChange", "disableDefault", "UIText", "working", "size", "clearOnUnmount");
  const { dispatch, UI, settings } = useUIBp();
  const active = UI[id] ?? 0;
  //   const { label, fixedTooltip, tooltip } = UIText[settings.locale];

  let tabs = [];
  let views = [];

  //   innerContentObj = {
  //     tabLabel: "",
  //     tabValue: "",
  //     tabContent: <></>,
  //   };

  const handleChange = (e, value) => {
    // if (!disableDefault) {
    dispatch(UIactions.setValue({ id, value }));
    if ( onChange){
        console.log("Tabs.js: running onChange");
        onChange()
    }
    // }
    // fn(value);
  };

  panels.forEach((tab, index) => {
    const { label, tabValue } = tab;
    tabs.push(<Tab key={tabValue} label={label} value={tabValue} sx={{width:"50%"}} />);
  });

  const activeView = useMemo(() => {
    return panels.find((tab) => tab.tabValue === active);
  }, [active, panels]);

  return (
    <Grid2 container {...{size}}>
      <Grid2 container {...{size:12}}>
        <MuiTabs {...{ value: active, onChange: handleChange, sx:{width:"100%"}, size:12  }}>{tabs}</MuiTabs>
      </Grid2>
      <Grid2 container {...{size,sx:{ marginTop: 2, size: 12 }}}>
        {activeView.content}
      </Grid2>
    </Grid2>
  );
};

export default Tabs;
